import { useState, useEffect } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { toast } from 'react-hot-toast';

export default function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        toast.success('Connection restored', {
          icon: '✅',
          duration: 3000,
        });
        setWasOffline(false);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      toast.error('You are offline. Some features may be limited.', {
        icon: '⚠️',
        duration: 5000,
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  // Don't show anything if online
  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-auto z-30 bg-yellow-500 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 animate-pulse safe-bottom">
      <FaExclamationTriangle className="w-5 h-5 flex-shrink-0" />
      <span className="text-sm font-medium">Offline Mode</span>
    </div>
  );
}

